import React from "react";
import ParaplanningInputField from "./ParaplanningInputField";
import ParaplanningSelectField from "./ParaplanningSelectField";
import { ReactComponent as AddIcon } from "../../../assets/icons/add.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";

const AdditionalChargesSection = ({
  formData,
  additionalChargeOptions,
  onAddCharge,
  onChargeSelect,
  onFieldChange,
  selectedModifiers,
  getSelectedModifierDropdownValue,
  onModifierTypeChange,
  onModifierFieldChange,
  onRemoveModifier,
}) => {
  return (
    <div className="ParaplanningField ParaplanningField--Full">
      <span className="ParaplanningAdditionalCharges__AddNew FP_Body">
        Additional Charges
      </span>

      <div className="ParaplanningAdditionalCharges__Row">
        <div className="ParaplanningAdditionalCharges__Select">
          <ParaplanningSelectField
            value={formData.additionalChargeCatalogId}
            placeholder="Select charge"
            options={additionalChargeOptions}
            onChange={onChargeSelect}
          />
        </div>

        <div className="ParaplanningAdditionalCharges__Amount">
          <ParaplanningInputField
            value={formData.additionalChargeAmount}
            placeholder={
              formData.additionalChargeIsDiscount ? "Discount amount" : "£0.00"
            }
            onChange={(value) => onFieldChange("additionalChargeAmount", value)}
          />
        </div>

        <div className="ParaplanningAdditionalCharges__Qty">
          <ParaplanningInputField
            value={String(formData.additionalChargeQuantity || 1)}
            placeholder="Qty"
            onChange={(value) =>
              onFieldChange(
                "additionalChargeQuantity",
                Math.max(Number(value || 1), 1),
              )
            }
          />
        </div>
      <button
        type="button"
        className="ParaplanningAdditionalCharges__IconButton"
        onClick={onAddCharge}
        aria-label="Add additional charge"
      >
        <AddIcon />
      </button>
      </div>

      {!!selectedModifiers.length && (
        <div className="ParaplanningSelectedCharges">
          {selectedModifiers.map((modifier) => (
            <div key={modifier.id} className="ParaplanningSelectedCharges__Row">
              <div className="ParaplanningSelectedCharges__Name">
                <ParaplanningSelectField
                  value={getSelectedModifierDropdownValue(modifier)}
                  placeholder="Select charge"
                  options={additionalChargeOptions}
                  onChange={(value) => onModifierTypeChange(modifier.id, value)}
                />
              </div>

              <div className="ParaplanningSelectedCharges__Amount">
                <ParaplanningInputField
                  value={
                    modifier.isDiscount
                      ? `-${String(modifier.amount)}`
                      : String(modifier.amount)
                  }
                  placeholder="£0.00"
                  onChange={(value) =>
                    onModifierFieldChange(modifier.id, "amount", value)
                  }
                />
              </div>

              <div className="ParaplanningSelectedCharges__Qty">
                <ParaplanningInputField
                  value={String(modifier.quantity || 1)}
                  placeholder="Qty"
                  onChange={(value) =>
                    onModifierFieldChange(modifier.id, "quantity", value)
                  }
                />
              </div>

              <button
                type="button"
                className="ParaplanningAdditionalCharges__IconButton ParaplanningAdditionalCharges__IconButton--Delete"
                onClick={() => onRemoveModifier(modifier.id)}
                aria-label="Remove additional charge"
              >
                <DeleteIcon />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdditionalChargesSection;
